<template>
  <q-dialog
    v-model="state.show"
    persistent
  >
    <div class="row" style="background:rgb(237, 238, 242);padding:10px 10px;max-width:none;position:relative;">
      <div class="col" ref="video-block" style="position:relative">
        <q-fab color="primary" icon="keyboard_arrow_right" direction="right" padding="xs" style="position:absolute;left:10px;top:10px;">
          <q-fab-action class="mqfab" color="secondary" @click="changeResolution('hd')" label="hd" padding="xs" />
          <q-fab-action class="mqfab" color="secondary" @click="changeResolution('vga')" label="vga" padding="xs" />
          <q-fab-action class="mqfab" color="secondary" @click="changeResolution('qvga')" label="qvga" padding="xs" />
        </q-fab>
        <div class="outsideWrapper">
          <div class="insideWrapper">
            <video ref="video" class="coveredVideo" id="gum-res-local" playsinline autoplay muted></video>
            <canvas ref="overlay" class="coveringCanvas"></canvas>
          </div>
        </div>
        
        <q-page-sticky position="bottom-right" style="position:absolute;right:10px;bottom:10px;">

          <q-btn fab icon="play_arrow" color="red" padding="sm" @click="createSequence"  />
          <q-btn fab icon="camera" color="accent" padding="sm" @click="capture" />
          <q-btn fab icon="close" color="blue" padding="sm" @click="close" />
        </q-page-sticky>
      </div>
  
      <div v-if="state.loadingLayer.show" style="position:absolute;background:#FFFFFFAA;width:100%;height:100%;left:0px;top:0px;z-index:99999;display:flex;flex-direction:column;justify-content:center;align-items:center;">
        <q-spinner-facebook
            color="primary"
            size="2em"
          />
        {{ state.loadingLayer.message }}
      </div>
    </div>
  </q-dialog>
  </template>
  
  <script>
  /* eslint-disable no-unused-vars */
  import io from 'socket.io-client';
  import Media from '@/js/media.js'
  import MediaDrawing from '@/js/media_drawing.js'
  import PARSE from '@/js/parse.js'
  import MISC from '@/js/miscellaneous.js'
  
  export default {
    props: {resolution: String, recognitionType: String},
    components: {
    },
    data: function () {
      const Vue = this
      return {
        stream: null,
        loaded: false,
        constraints: {
          qvga: {audio: false, video: {width: 320, height: 240, facingMode: "environment"}},
          vga: {audio: false, video: {width: 640, height: 480, facingMode: "environment"}},
          hd: {audio: false, video: {width: 1280, height: 720, facingMode: "environment"}}
        },
        state: {
          show: true,
          constraints: Vue.resolution,
          loadingLayer: {
            show: false,
            message: '해상도를 변경하는 중 입니다...'
          }
        },
        processInterval: null,
        static_id: null,
        STREAM_NAME: +new Date(),
        socket: null,
      }
    },
    methods: {
      async capture () {
        const Vue = this
        if (this.processInterval) {
          clearInterval(this.processInterval)
        }
        if (null != this.socket) {
          console.log('socket.close')
          this.socket.close();
          this.socket = null;
        }

        if (Vue.loaded == true) {
          const video = this.$refs['video'];
          const canvas = document.createElement('canvas')
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
          
          const today = new Date();
          const date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
          const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
          
          const f = new Promise(function (resolve, reject) {
            canvas.toBlob(function (blob) {
              try {
                const file = new File([blob], `${date}_${time}.jpg`, {type: 'image/jpeg'})
                resolve(file)
              } catch (e) {
                reject(e)
              }
              // 
            }, 'image/jpeg')
          })
          f.then((file) => {
            // console.log(file)
            Vue.$emit('oncapture', {resolution: Vue.state.constraints, file: file, aa: 123})
          }).catch((e) => {
            console.log(e)
            this.$emit('oncapture', {resolution: Vue.state.constraints})
          })
        } else
          this.$emit('oncapture', {resolution: Vue.state.constraints})
      },
      resizeCanvas(w, h) {
        const canvas = this.$refs['overlay'];
        canvas.width = w;
        canvas.height = h;       
      },
      // processFaceMesh() {
      //   const canvas = this.$refs['overlay'];
      //   this.processInterval = setInterval ( async () => {
      //     console.log('play interval', canvas.width, canvas.height)
      //     canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height)
      //     let ctx = canvas.getContext("2d");
      //     ctx.beginPath();
      //     ctx.lineWidth = "6";
      //     ctx.strokeStyle = "red";
      //     ctx.rect(5, 5, 290, 140);
      //     ctx.stroke();
      //   }, 1000)
      // },
      sendFile(file, chunkNumber) {
        const formData = new FormData();
  
        formData.append('file', file);
        formData.append('name', this.STREAM_NAME);
        formData.append('chunk', chunkNumber);
  
        fetch('/api/upload', {
          method: 'PUT',
          body: formData
        });
      },
      registerRecord(stream) {
        const mediaRecorder = new MediaRecorder(stream)
        let countUploadChunk = 0
  
        mediaRecorder.ondataavailable = (data) => {
          this.sendFile(data.data, countUploadChunk)
          countUploadChunk++
        }
        mediaRecorder.start()
  
        setInterval(() => {
          mediaRecorder.requestData()
        }, 2000)
      }, 
      registerPlayer(mediaSource) {
        const videoBuffer = mediaSource.addSourceBuffer('video/webm;codecs=vp8');
        let countDownloadChunk = 0
  
        this.processInterval = setInterval(() => {        
          fetch(`/api/download?name=${this.STREAM_NAME}&chunk=${countDownloadChunk}`)
              .then((response) => {
                  if (response.status !== 200) {
                      throw Error('no such file')
                  }
                  return response.arrayBuffer()
              }).then((buffer) => {
                  countDownloadChunk++
                  videoBuffer.appendBuffer(buffer)
              }).catch(() => {})
        }, 1000)
      },
      processStream(stream, mediaSource) {
        this.registerRecord(stream)
        this.registerPlayer(mediaSource)
      },
      processSequence () {
        const Vue = this
        const video = this.$refs['video'];
        const canvas = this.$refs['overlay'];
        let ctx = canvas.getContext("2d");

        const data_canvas = document.createElement('canvas')
        data_canvas.width = video.videoWidth;
        data_canvas.height = video.videoHeight;
        
        const ip_address = `wss://${process.env.VUE_APP_MEDIA_IP}:${process.env.VUE_APP_MEDIA_PORT}/ws`
        console.log(Vue.recognitionType)
        Vue.socket = new WebSocket(ip_address, Vue.recognitionType);
        Vue.socket.onopen = function (event) {
          console.log('onopen');
          Vue.processInterval = setInterval(async () => {
            var nStart = new Date().getTime();      //시작시간 체크(단위 ms)

            // canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
            data_canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
            var jpegUrl = data_canvas.toDataURL("image/jpeg");
            let object = {date: Date.now(), recog_type: Vue.recognitionType,  base64: jpegUrl}
            Vue.socket.send(JSON.stringify(object))
            var nEnd =  new Date().getTime();      //종료시간 체크(단위 ms)

            var nDiff = nEnd - nStart;      //두 시간차 계산(단위 ms)
            console.log(nDiff + "ms");
          }, 33);   
        };
        Vue.socket.onmessage = function (event) {
          let msg = JSON.parse(event.data)

          ctx.clearRect(0, 0, canvas.width, canvas.height)
          console.log('onmessage: ', Vue.recognitionType);
          if ('face-mesh' == Vue.recognitionType) {
            MediaDrawing.drawFaceMesh(ctx, msg)
          } else if ('hands' == Vue.recognitionType) {
            MediaDrawing.drawHands(ctx, msg)
          } else if ('pose-estimation' == Vue.recognitionType) {
            MediaDrawing.drawPose(ctx, msg)
          } else if ('object-detection' == Vue.recognitionType) {
            MediaDrawing.drawDetection(ctx, msg)
          } else if ('iris' == Vue.recognitionType) {
            MediaDrawing.drawIris(ctx, msg)
          } else if ('selfie-segmentation' == Vue.recognitionType) {
            MediaDrawing.drawBase64(ctx, msg)
          } else if ('hair-segmentation' == Vue.recognitionType) {
            MediaDrawing.drawBase64(ctx, msg)
          }
        }
      },   
      createSequence () {     
        this.processSequence()

      }, 
      close() {
        const Vue = this
        console.log('recognitionType: ', this.recognitionType)
        if (null != this.socket) {
          console.log('socket.close')
          this.socket.close();
          this.socket = null;
        }
        if (this.processInterval) {
          clearInterval(this.processInterval)
        }
        this.$emit('oncapture', {resolution: Vue.state.constraints})
      }, 
      gotStream (mediaStream, mediaSource) {
        this.stream = window.stream = mediaStream; // stream available to console
        const video = this.$refs['video'];
        video.srcObject = mediaStream;
        const track = mediaStream.getVideoTracks()[0];
        const constraints = track.getConstraints();
        
        const videoBlock = this.$refs['video-block'];
        videoBlock.style.width = `${constraints.width}px`;
        videoBlock.style.height = `${constraints.height}px`;
        this.loaded = true
        this.state.loadingLayer.show = false
        this.resizeCanvas(constraints.width, constraints.height)
      },
      getMedia (constraints) {
        const Vue = this
        if (this.stream) {
          this.stream.getTracks().forEach(track => {
            track.stop();
          });
        }
        if (window.navigator == undefined || window.navigator.mediaDevices == undefined || window.navigator.mediaDevices.getUserMedia == undefined) {
          this.$q.notify({message: "호환 불가능한 browser / version 입니다 ", icon: 'error', color: 'purple'})
          // this.$q.notify({message: "navigator.mediaDevices.getUserMedia is undefined", icon: 'error', color: 'red'})
          this.state.loadingLayer.show = false
          this.$emit('onerror')
        } else {
          const video = this.$refs['video'];
          const mediaSource = new MediaSource();
          video.src = URL.createObjectURL(mediaSource);
          window.navigator.mediaDevices.getUserMedia(constraints)
              .then( (stream) => this.gotStream(stream, mediaSource) )
              .catch(e => {
                console.log(e)
                this.$q.notify({message: "카메라를 얻어오지 못했습니다", icon: 'error', color: 'purple'})
                this.state.loadingLayer.show = false
                this.$emit('onerror')
              })
        }
      },
      changeResolution: function (mode) {
        this.state.loadingLayer.show = true
        this.loaded = false
        this.state.constraints = mode
        this.getMedia(this.constraints[this.state.constraints]);
      }
    },
    mounted () {
      this.$nextTick(()=>{
        this.changeResolution(this.state.constraints);
      });
    },
    beforeDestroy () {
      if (this.stream) {
        this.stream.getTracks().forEach(track => {
          track.stop();
        });
      }
    }
  }
  </script>
  
  <style>
  .mqfab div.q-fab__label--internal-right {
    padding-left: 2px !important;
    padding-right: 2px !important;
    margin-top: -2px !important;
    font-size:12px;
  }
  .outsideWrapper{ 
      width:100%; height:100%
  }
  .insideWrapper{ 
      width:100%; height:100%; 
      position:relative;}
  .coveredVideo{ 
      width:100%; height:100%; 
      position:absolute; top:0px; left:0px;
  }
  .coveringCanvas{ 
      width:100%; height:100%; 
      position:absolute; top:0px; left:0px;
      background-color: rgba(0, 0, 0, 0);
  }
  </style>